exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table.table-bordered td[data-v-a1785b5e],.table.table-bordered th[data-v-a1785b5e]{font-size:13px!important;vertical-align:middle!important}[dir] .table.table-bordered td[data-v-a1785b5e],[dir] .table.table-bordered th[data-v-a1785b5e]{padding:4px 8px!important}[dir] .table.table-bordered[data-v-a1785b5e]{margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a1785b5e","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orderStatus/orderStatusSettings.vue
// module id = 1502
// module chunks = 0